import React, { ReactNode } from "react";
import { Tooltip } from "@mui/material";
import { InfoIcon } from "assets";

export const InfoTooltip = ({ tooltip, width = '12', height = '12' }: { tooltip: string | ReactNode, width?: string, height?: string }) => (
  <Tooltip title={tooltip} placement="top" arrow>
    <InfoIcon height={height} width={width} />
  </Tooltip>
);
